import { api } from "./configs/axiosConfigs";

export const WeeklyMeetsAPI = {
  getMeets: async () => {
    const response = await api.get(
      `/weekly_meets?order_by=weekly_meet_date&order=desc&page=1&items_per_page=2000`,
    );

    return response?.data;
  },

  getMeet: async (id) => {
    const response = await api.get(`/weekly_meets/${id}`);

    return response?.data;
  },

  addMeet: async (form) => {
    const response = await api.post(`/weekly_meets`, form);

    return response?.data;
  },

  updateMeet: async (form, id) => {
    const response = await api.patch(`/weekly_meets/${id}`, form);

    return response?.data;
  },

  deleteMeet: async (id) => {
    const response = await api.delete(`/weekly_meets/${id}`);

    return response?.data;
  },
};
